import { Menu, Submenu, MenuItem } from '@tauri-apps/api/menu'
import { Window } from '@tauri-apps/api/window'
import { logger } from './lib/logger'

export async function setupNativeMenu() {
  try {
    const mainWindow = Window.getCurrent()
    
    // Create File menu items
    const quitItem = await MenuItem.new({
      id: 'quit',
      text: 'Quit',
      accelerator: 'CmdOrCtrl+Q',
      action: async () => {
        await mainWindow.close()
      }
    })

    const fileSubmenu = await Submenu.new({
      text: 'File',
      items: [quitItem]
    })

    // Create View menu items
    const toggleDevToolsItem = await MenuItem.new({
      id: 'toggle-devtools',
      text: 'Toggle DevTools',
      accelerator: 'CmdOrCtrl+Shift+I',
      action: async () => {
        try {
          await (mainWindow as any).toggleDevtools()
          logger.info('🔧 DevTools toggled via menu')
        } catch (error) {
          logger.error('Failed to toggle DevTools:', error)
        }
      }
    })

    const reloadItem = await MenuItem.new({
      id: 'reload',
      text: 'Reload',
      accelerator: 'CmdOrCtrl+R',
      action: async () => {
        window.location.reload()
      }
    })

    const toggleFullscreenItem = await MenuItem.new({
      id: 'toggle-fullscreen',
      text: 'Toggle Fullscreen',
      accelerator: 'F11',
      action: async () => {
        const isFullscreen = await mainWindow.isFullscreen()
        await mainWindow.setFullscreen(!isFullscreen)
      }
    })

    const viewSubmenu = await Submenu.new({
      text: 'View',
      items: [toggleDevToolsItem, reloadItem, toggleFullscreenItem]
    })

    // Create Help menu items
    const aboutItem = await MenuItem.new({
      id: 'about',
      text: 'About',
      action: () => {
        logger.info('About Veil into Worlds v0.1.0')
      }
    })

    const helpSubmenu = await Submenu.new({
      text: 'Help',
      items: [aboutItem]
    })

    // Create the main menu bar
    const menu = await Menu.new({
      items: [fileSubmenu, viewSubmenu, helpSubmenu]
    })

    // Set the menu for the window
    await (mainWindow as any).setMenu(menu)
    
    logger.success('✅ Native menu initialized')
  } catch (error) {
    logger.error('❌ Failed to initialize native menu:', error)
  }
}
